module.exports = __webpack_public_path__ + "static/img/tab.eaf0628.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/advertisement/tab.jpg
// module id = T+P4
// module chunks = 171